export const USER_SIGN_UP = "USER_SIGN_UP";
export const USER_SIGN_IN = "USER_SIGN_IN";
export const USER_SIGN_IN_FAILED = "USER_SIGN_IN_FAILED";
export const USER_SIGN_OUT = "USER_SIGN_OUT";
export const USER_UPDATE_PROFILE = "USER_UPDATE_PROFILE";
export const USER_CHANGE_PASSWORD = "USER_CHANGE_PASSWORD";
export const ADD_CUSTOMER = "ADD_CUSTOMER";
export const REMOVE_CUSTOMER = "REMOVE_CUSTOMER"
export const CHECK_USER = "CHECK_USER";
